import React, { useState, useEffect } from 'react';
import './CategoryMenuItemLister.scss';
import { IonGrid, IonContent, IonRow } from '@ionic/react';
import CategoryGrid from '../components/CategoryGrid';
import MenuItemRow from '../components/MenuItemRow';
import { baseUrl, cacheBust } from '../helpers/configHelper';
import CategoryFilters from './CategoryFilters';
import { useLocation, useHistory } from "react-router-dom";

import { CategoryList, MopCategory, MopMenuItem } from '../store/MenuStoreTypes';
import { useDispatch } from 'react-redux';
import * as DealStore from '../store/DealStore';

interface CategoryMenuItemListerProps {
    categoryList: CategoryList | null,
    onNavigateToCategory?: (categoryId: number) => void;
    onNavigateToMenuItem?: (menuItemId: number) => void;
    isColleague?: boolean;
}

const CategoryMenuItemLister: React.FC<CategoryMenuItemListerProps> = ({
    categoryList,
    onNavigateToCategory,
    onNavigateToMenuItem,
    isColleague,
}) => {
    const [selectedFilter, setSelectedFilter] = useState<string | null>();
    const location = useLocation()
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        console.log("Category Info:", categoryList);

        if (categoryList && categoryList.categories) {
            categoryList.categories.forEach((c: MopCategory) => {
                if (c.deals) {
                    dispatch(DealStore.actionCreators.updateDeals(c.deals.items));
                }
            });
        }
    }, [categoryList]);

    function handleMenuItemClick(menuItemId: number) {
        if (onNavigateToMenuItem) {
            onNavigateToMenuItem(menuItemId);
        }
    }

    const onClickCategory = (category: MopCategory) => {
        if (location.pathname !== "/categories" && category.menuItemIds && category.menuItemIds.length === 1 && (!category.subCategoryIds || category.subCategoryIds.length === 0)) {
            if (onNavigateToMenuItem) {
                onNavigateToMenuItem(category.menuItemIds[0]);
            }
            else {
                console.log("ERROR: onNavigateToMenuItem undefined");
            }
        }
        else {
            if (onNavigateToCategory) {
                onNavigateToCategory(category.categoryId);
            }
            else {
                console.log("ERROR: onNavigateToCategory undefined");
            }
        }
    }

    const onFilterSelected = (newSelectedFilter: string) => {
        if (newSelectedFilter == selectedFilter) {
            setSelectedFilter(null);
            return;
        }

        setSelectedFilter(newSelectedFilter);
        return;
    }

    return (
        <IonContent fullscreen
            class='CategoryListContent category-wrapper'
            style={{
                "--background": categoryList?.auxCategoryData?.categoryColours.background ?? "#F2F2F2",
            }}
        >

            {
                categoryList?.isFavourites &&
                <>
                    {!categoryList?.menuItems.length &&
                        <p className="no-favourites">
                            Your favourites will appear here after you place an order
                        </p>
                    }
                </>
            }

            <IonGrid
                className="padding-none"
            >
                {
                    categoryList && categoryList.categories && !categoryList.menuItems &&
                    <>
                        <div className="favourites-box">
                            {
                                categoryList.categories
                                    .filter((a: MopCategory) => {
                                        return a.isFavourites;
                                    })
                                    .map((a: MopCategory) => {
                                        return <CategoryGrid key={"ee" + a.categoryId} categoryId={a.categoryId} categoryImage={a.categoryImage} categoryName={a.categoryName} isFavourites={a.isFavourites} fullWidth={a.isFavourites ? true : false} onClick={() => onClickCategory(a)} sortOrder={a.sortOrder} />
                                    })
                            }
                        </div>
                        <div className="menu-box">
                            <IonRow className="categoryGrid">
                                {
                                    categoryList.categories
                                        .filter((a: MopCategory) => {
                                            if (isColleague && a.deals) {
                                                return false;
                                            }

                                            return !a.isFavourites;
                                        })
                                        .sort((a: MopCategory, b: MopCategory) => {
                                            // NOTE: The deals category has no sortOrder, but
                                            // should be displayed at the end of the list.
                                            if (a.deals) {
                                                return 1;
                                            }

                                            if (b.deals) {
                                                return -1;
                                            }

                                            return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
                                        })
                                        .map((a: MopCategory) => {
                                            if (a.deals) {
                                                return (
                                                    <CategoryGrid
                                                        categoryId={9999}
                                                        categoryName="The Deals"
                                                        categoryImage="Deals.png"
                                                        isFavourites={false}
                                                        fullWidth={false}
                                                        onClick={() => history.push(`/deals`)}
                                                    />
                                                )
                                            } else {
                                                return <CategoryGrid key={"ee" + a.categoryId} categoryId={a.categoryId} categoryImage={a.categoryImage} categoryName={a.categoryName} isFavourites={a.isFavourites} fullWidth={a.isFavourites ? true : false} onClick={() => onClickCategory(a)} sortOrder={a.sortOrder} />
                                            }
                                        })
                                }
                            </IonRow>
                        </div>
                    </>
                }

                {
                    categoryList && categoryList.menuItems &&
                    <>
                        {
                            <>
                                {(categoryList.tagImageUrl && false) &&
                                    <IonRow>
                                        <img
                                            alt=""
                                            src={`${baseUrl()}/images/PromoBanners/${categoryList?.tagImageUrl?.replace('/Content/Images/', '')}?v=${cacheBust()}`}
                                            className="category-promo-banner"
                                        />
                                    </IonRow>
                                }
                                {categoryList.showFilters !== false &&
                                    <CategoryFilters
                                        onFilterSelected={onFilterSelected}
                                        selectedFilter={selectedFilter}
                                        menuItems={categoryList.menuItems}
                                    />
                                }
                                {
                                    categoryList.menuItems
                                        .filter((v: MopMenuItem) => {
                                            if (selectedFilter && selectedFilter !== '') {
                                                return v.categoryLevelFilter === selectedFilter;
                                            }

                                            return v.itemTags.indexOf('[DEAL]') === -1;
                                        })
                                        //.sort((a: MopMenuItem, b: MopMenuItem) => {
                                        //    // Move items with graphicTreatment to top.
                                        //    const aHasFlag = a.auxData ? a.auxData.graphicTreatment !== null : false;
                                        //    const bHasFlag = b.auxData ? b.auxData.graphicTreatment !== null : false;

                                        //    if (aHasFlag && !bHasFlag) return -1;
                                        //    if (!aHasFlag && bHasFlag) return 1;

                                        //    return (b.sortOrder ?? 0) - (a.sortOrder ?? 0);
                                        //})
                                        .map((a: MopMenuItem) => (
                                            <MenuItemRow
                                                menuItemFromPrice={a.menuItemFromPrice}
                                                key={"ef" + a.menuItemId}
                                                menuItemId={a.menuItemId}
                                                menuItemImage={a.menuItemImage}
                                                inStock={a.inStock}
                                                menuItemBasePrice={a.menuItemBasePrice}
                                                menuItemName={a.menuItemName}
                                                onClick={handleMenuItemClick}
                                                sku={a.sku}
                                                productFlags={a.productFlags}
                                                kcal={a.kcal}
                                                separatorColour={categoryList?.auxCategoryData?.categoryColours.separator ?? ""}
                                                rolledUpItems={a.rolledUpItems}
                                                hasBrandImage={a.hasBrandImage}
                                                graphicTreatment={a.auxData?.graphicTreatment}
                                                backgroundStyle={a.auxData?.backgroundStyle}
                                                description={a.description}
                                            />
                                        ))
                                }
                            </>
                        }
                    </>
                }
            </IonGrid>
        </IonContent>
    );
};

export default CategoryMenuItemLister;
